import { Outlet } from 'react-router-dom'
import { LanguageSwitcher } from '../portal/LanguageSwitcher'
import { PortalBackground } from '../portal/PortalBackground'

/**
 * Auth (login / register) layout.
 *
 * Shares the same ambient background as the rest of the public portal
 * (PortalBackground — the blue→white→cyan gradient + soft drifting orbs), so the
 * auth pages are visually continuous with the site. Previously this carried its
 * own heavier framer-motion particle/ring/dot layer; that was replaced with the
 * shared, lighter, reduced-motion-safe background for consistency + performance.
 */
const AuthLayout = () => {
  return (
    <div className="min-h-screen relative">
      {/* Language switcher — prominent, top-right, always visible on auth pages */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageSwitcher />
      </div>

      {/* Shared site background (decorative, fixed, behind content) */}
      <PortalBackground />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center p-6">
        <Outlet />
      </div>
    </div>
  )
}

export default AuthLayout